<div class="application-nav-container">
  <div class="application-nav-container__button application-nav-container__button--prev">
    <button
      *ngIf="!appState.isTeleInterviewerLoggedIn || !isFirstSection"
      cp-button
      theme="blue-alt"
      variant="primary"
      size="large"
      [disabled]="isFirstSection"
      (click)="previousSection()"
    >
      Back
    </button>
  </div>
  <div
    *ngIf="!isLastSection"
    class="application-nav-container__button application-nav-container__button--next"
    [class.application-nav-container__button--next-left]="isFirstSection"
  >
    <button *ngIf="showNextButton()" cp-button size="large" (click)="nextSection()" [disabled]="disableNextButton()">
      Next
    </button>
    <button *ngIf="showValidateButton()" cp-button size="large" [disabled]="true">Validating ...</button>
  </div>
  <div
    *ngIf="isLastSection && (!appState.isAdvisor || appState.isTeleInterviewerLoggedIn)"
    class="application-nav-container__button application-nav-container__button--next"
    [ngClass]="{
      'application-nav-container__button--next-left': isFirstSection
    }"
  >
    <ng-template [ngIf]="altSubmitSignVerbiageEnabled">
      <ng-template [ngIf]="!appState.isTeleInterviewerLoggedIn">
        <button
          cpdsButton
          size="large"
          *cpdsTooltip="
            'After submitting, the next step is to sign your application.';
            type: 'description';
            position: 'top'
          "
          [disabled]="!isSubmitEnabled()"
          (click)="submitFromNavigation()"
        >
          Submit Application
        </button>
      </ng-template>
      <ng-template [ngIf]="appState.isTeleInterviewerLoggedIn">
        <button
          cpdsButton
          size="large"
          *cpdsTooltip="
            'After submitting, the next step is to sign your application.';
            type: 'description';
            position: 'top'
          "
          [disabled]="!isTeleSubmitEnabled()"
          (click)="teleInterviewerSubmitFromNavigation()"
        >
          Ready to Submit
        </button>
      </ng-template>
    </ng-template>

    <ng-template [ngIf]="!altSubmitSignVerbiageEnabled">
      <button
        *ngIf="!appState.isTeleInterviewerLoggedIn"
        cp-button
        size="large"
        [disabled]="!isSubmitEnabled()"
        (click)="submitFromNavigation()"
      >
        Submit Application
      </button>
      <button
        *ngIf="appState.isTeleInterviewerLoggedIn"
        cp-button
        size="large"
        [disabled]="!isTeleSubmitEnabled()"
        (click)="teleInterviewerSubmitFromNavigation()"
      >
        Ready to Submit
      </button>
    </ng-template>
  </div>
</div>
